// @ts-ignore
import zoid from '@krakenjs/zoid/dist/zoid.frameworks';
import {CofidisProps} from './types';
import {ComponentOptionsType, MoneiComponent} from '../../types/component';
import {config} from '../config';
import {CofidisModal} from './modal';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import {getPaymentMethods} from '../api';
import {GetPaymentMethodsResponse} from '../types';

export * from './types';
export * from './modal';
export * from './widget';

const options: ComponentOptionsType<CofidisProps> = {
  tag: 'monei-cofidis-button',
  url: config.cofidisButtonUrl,
  dimensions: {
    width: '100%',
    height: '45px'
  },
  autoResize: {
    width: false,
    height: true
  },
  validate: validateComponentProps,
  containerTemplate,
  prerenderTemplate: () => undefined,
  props: {
    paymentId: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    language: {
      type: zoid.PROP_TYPE.STRING,
      required: false
    },
    hint: {
      type: zoid.PROP_TYPE.BOOLEAN,
      default: () => true,
      required: false
    },
    onError: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onLoad: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onBeforeOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    onOpen: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false
    },
    style: {
      type: zoid.PROP_TYPE.OBJECT,
      alias: 'innerStyle',
      required: false
    },
    __getConfig: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        return getPaymentMethods.bind(null, props);
      }
    },
    __onHintClick: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: () => {
        return (url: string) => {
          window.open(url, '_blank');
        };
      }
    },
    __onClick: {
      type: zoid.PROP_TYPE.FUNCTION,
      required: false,
      value: ({props}: any) => {
        const rootNode = document.createElement('div');
        document.body.appendChild(rootNode);
        return ({amount, currency, accountId}: GetPaymentMethodsResponse) => {
          let shouldOpen = true;
          if (props.onBeforeOpen) {
            shouldOpen = props.onBeforeOpen();
          }
          if (!shouldOpen) return;
          const cofidisModal = new CofidisModal({
            ...props,
            amount,
            currency,
            accountId,
            onClose: () => {
              window.onpopstate = null;
              document.body.style.overflow = '';
            },
            isOpen: true
          });
          window.history.pushState(null, '', window.location.href);
          window.onpopstate = () => cofidisModal.updateProps({isOpen: false});
          Object.assign(document.body.style, {overflow: 'hidden'});
          return cofidisModal.render(rootNode);
        };
      }
    }
  }
};

export const Cofidis: MoneiComponent<CofidisProps> = zoid.create(options);
